// import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Md5 } from 'ts-md5';

import { AOFaunaDbService } from './ao-fauna-db.service';

// @Injectable({
//   providedIn: 'root'
// })
export class AOCacheService {

  private _configs: any = {
    type: 'full', // none|local|server|full
    expire: ((24 * 60 * 60) * 1000),
    metadata: {},
  };

  constructor(
    private _db: AOFaunaDbService,
    private _storage: LocalStorageService,
  ) {
  }

  find(params: any, request: () => Promise<any>, configs: any = {}) {

    configs = (typeof configs === 'object') ? {...this._configs, ...configs} : {...this._configs};

    return new Promise(async (resolve, reject) => {

      params = JSON.stringify(params);
      const key = Md5.hashStr(params);

      const cached = await this.get(key, configs);
      if (cached) {
        return resolve(cached);
      }

      request().then(async response => {
        await this.set(key, params, response, configs);
        return resolve(response);
      });

    });
  }

  async get(key, configs: any) {
    console.log('Cache::get', key);

    const response = this._storage.retrieve(key);
    const response_updated_at = this._storage.retrieve(key + '_updated_at');

    if (
      response != null
      && response_updated_at != null
      && (Date.now() - response_updated_at) <= configs.expire
    ) {
      return JSON.parse(response);
    }

    return await this.getInServer(key, configs);
  }

  async getInServer(key, configs: any) {
    let cached = null;

    try {
      cached = await this._db.query(q => q.Get(q.Match(q.Index('cache_by_key'), key)));
    } catch (e) {
      return null;
    }

    this._storage.store(key, cached.data.response);
    this._storage.store(key + '_updated_at', cached.data.updated_at);

    if ((Date.now() - cached.data.updated_at) > configs.expire) {
      return null;
    }

    return JSON.parse(cached.data.response);
  }

  set(key, request, response, configs: any) {
    const data = {
      key,
      request,
      response: JSON.stringify(response),
      updated_at: Date.now(),
      metadata: configs.metadata
    };

    this._storage.store(key, data.response);
    this._storage.store(key + '_updated_at', data.updated_at);

    return this.setInServer(key, data);
  }

  setInServer(key, data) {
    return this._db.query(q => q.If(
      q.Exists(q.Match(q.Index('cache_by_key'), key)),
      q.Update(q.Select(['ref'], q.Get(q.Match(q.Index('cache_by_key'), key))), {data: {...data}}),
      q.Create(q.Collection('cache'), {data: {...data, created_at: Date.now()}})
    ));
  }

}
